<script setup lang="ts">
import { systemUser } from "@/main-store";
import Permissions from "@utils/Permissions";
import { useRoute } from "vue-router";
const route = useRoute()
</script>
<template>
    <nav class="sidebar overflow-y-auto">
        <ul>
            <li :class="{ active: route.path == '/admin/memos' }">
                <router-link to="/admin/memos">
                    <i class="fas fa-inbox"></i> Memos
                </router-link>
            </li>
            <li :class="{ active: route.path == '/admin/leads' }">
                <router-link to="/admin/leads">
                    <i class="fa-solid fa-user"></i> Leads
                </router-link>
            </li>
        </ul>
        <hr>
        <ul>
            <li :class="{ active: route.path == '/admin/organizations' }"
                v-if="systemUser.permissions.includes(Permissions.SuperAdmin.ManageClinics)">
                <router-link to="/admin/organizations">
                    <i class="fa-solid fa-hospital"></i> Organizations
                </router-link>
            </li>
            <li :class="{ active: route.path == '/admin/organizations/a2p' }"
                v-if="systemUser.permissions.includes(Permissions.SuperAdmin.ManageClinics)">
                <router-link to="/admin/organizations/a2p">
                    <i class="fa fa-file"></i> A2P Registrations
                </router-link>
            </li>
            <li :class="{ active: route.path == '/admin/clinics' }"
                v-if="systemUser.permissions.includes(Permissions.SuperAdmin.CreateClinics)">
                <router-link to="/admin/clinics">
                    <i class="fa fa-address-card"></i> Clinics
                </router-link>
            </li>
            <li :class="{ active: route.path == '/admin/clinics/setup' }"
                v-if="systemUser.permissions.includes(Permissions.SuperAdmin.CreateClinics)">
                <router-link to="/admin/clinics/setup">
                    <i class="fas fa-plus"></i> Setup New Clinic
                </router-link>
            </li>
            <li :class="{ active: route.path == '/admin/clinics/open-invoices' }">
                <router-link to="/admin/clinics/open-invoices">
                    <i class="fa fa-file-invoice"></i> Open Invoices
                </router-link>
            </li>
        </ul>
        <hr />
        <ul>
            <li :class="{ active: route.path == '/admin/master-items' }">
                <router-link to="/admin/master-items">
                    <i class="fa fa-barcode"></i> Master Items
                </router-link>
            </li>
            <li :class="{ active: route.path == '/admin/species' }">
                <router-link to="/admin/species">
                    <i class="fas fa-dog"></i> Species
                </router-link>
            </li>
            <li :class="{ active: route.path == '/admin/colors' }">
                <router-link to="/admin/colors">
                    <i class="fas fa-palette"></i> Colors
                </router-link>
            </li>
            <li :class="{ active: route.path == '/admin/drugs' }">
                <router-link to="/admin/drugs">
                    <i class="fas fa-syringe"></i> Drugs
                </router-link>
            </li>
            <li :class="{ active: route.path == '/admin/distributors' }">
                <router-link to="/admin/distributors">
                    <i class="fas fa-shipping-fast"></i> Distributors
                </router-link>
            </li>
            <li :class="{ active: route.path == '/admin/manufacturers' }">
                <router-link to="/admin/manufacturers">
                    <i class="fa fa-industry"></i> Manufacturers
                </router-link>
            </li>
            <li :class="{ active: route.path == '/admin/microchip-companies' }">
                <router-link to="/admin/microchip-companies">
                    <i class="fas fa-microchip"></i> Microchip Companies
                </router-link>
            </li>
        </ul>
        <hr>
        <h5>Reports</h5>
        <ul>
            <li :class="{ active: route.path == '/admin/reports/microchip-analysis' }">
                <router-link to="/admin/reports/microchip-analysis">
                    <i class="fas fa-list"></i> Microchip Analysis
                </router-link>
            </li>
            <li :class="{ active: route.path == '/admin/reports/clinic-stats' }">
                <router-link to="/admin/reports/clinic-stats">
                    <i class="fas fa-list"></i> Clinic Stats
                </router-link>
            </li>
            <li :class="{ active: route.path == '/admin/reports/clinic-pricing' }">
                <router-link to="/admin/reports/clinic-pricing">
                    <i class="fas fa-list"></i> Clinic Pricing
                </router-link>
            </li>
            <li :class="{ active: route.path == '/admin/reports/clinic-donations' }">
                <router-link to="/admin/reports/clinic-donations">
                    <i class="fas fa-list"></i> Clinic Donations
                </router-link>
            </li>
        </ul>
        <hr />
        <h5>Translations</h5>
        <ul>
            <li :class="{ active: route.meta.active == 'shelterluv' }">
                <router-link to="/admin/shelterluv">
                    <i class="fa-solid fa-clipboard-list"></i> Shelterluv
                </router-link>
            </li>
            <li :class="{ active: route.meta.active == 'pethealth' }">
                <router-link to="/admin/pethealth">
                    <i class="fa-solid fa-clipboard-list"></i> Pethealth
                </router-link>
            </li>
            <li :class="{ active: route.meta.active == 'petlink' }">
                <router-link to="/admin/petlink">
                    <i class="fa-solid fa-clipboard-list"></i> PetLink
                </router-link>
            </li>
            <li :class="{ active: route.meta.active == 'pet-point' }">
                <router-link to="/admin/pet-point">
                    <i class="fa-solid fa-clipboard-list"></i> PetPoint
                </router-link>
            </li>
        </ul>
        <hr />
        <ul>
            <li>
                <router-link to="/dashboard">
                    <i class="fas fa-undo"></i> Back to Clinic HQ
                </router-link>
            </li>
        </ul>
    </nav>
</template>